import useAPI, { RequestConfig } from './useApi';
import { useDispatch, useSelector } from 'react-redux';
import get from 'lodash/get';
import { notificationsActions } from '@lifeomic/phc-web-toolkit/dist/redux/modules/notifications';
import urls from '../../util/urls';
import { useIntl } from 'react-intl';
import { AxiosError, AxiosResponse } from 'axios';
import config from '../../util/config';
import { loginSelectors } from '../../redux/modules/Login';

const messages = {
  apiErrorMessage: {
    id: 'forgotPasswordEndpoint.apiErrorMessage',
    defaultMessage:
      'An error occurred when sending a password reset code.  Error: "{error}"',
  },
  genericError: {
    id: 'forgotPasswordEndpoint.genericError',
    defaultMessage: 'An error occurred when sending a password reset code',
  },
};

export type ForgotPasswordResponse = {};

function useForgotPasswordEndpoint() {
  const dispatch = useDispatch();
  const formatMessage = useIntl().formatMessage;
  const customClientId = useSelector(loginSelectors.selectCustomClientId);

  const clientId = customClientId || config.oauthClientId;

  const onFailure = (error: AxiosError) => {
    const errorMessage = get(error, 'response.data.error', null) as string;

    const notificationMessage = errorMessage
      ? formatMessage(messages.apiErrorMessage, { error: errorMessage })
      : formatMessage(messages.genericError);

    dispatch(
      notificationsActions.addNotification(notificationMessage, {
        statusType: 'error',
      })
    );
  };

  const makeAPIRequest = (
    username: string,
    onSuccess: (axiosResponse: AxiosResponse<ForgotPasswordResponse>) => void
  ): RequestConfig => ({
    url: urls.api.auth.forgotPassword,
    method: 'POST',
    headers: {
      'content-type': 'application/json',
    },
    data: {
      username,
      clientId,
    },
    onSuccess,
    onFailure,
  });

  return useAPI(makeAPIRequest);
}

export default useForgotPasswordEndpoint;
